jQuery_T4NT(document).ready(function($) {

     /**
     * Variant selection changed
     */
	  $( document ).on( "variant:change", function( evt, variant ) {
	    //console.log( variant );
	  });
  
  	$('#shopify-section-template--15604605550760__product-description').insertAfter('.product-infors .theiaStickySidebar');

});